module.exports = __webpack_public_path__ + "static/img/network-05.61ad9ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-05.jpg
// module id = 1FQJ
// module chunks = 1